/**
 * Tour Manager — lifecycle management for driver.js tours.
 *
 * Keeps track of the active driver instance so Turbolinks navigations
 * can tear it down cleanly, preventing orphaned overlays or JS errors.
 */

let activeDriver = null;

export function setActiveDriver(driver) {
  // Destroy any previously active tour first
  destroyActiveTour();
  activeDriver = driver;
}

export function destroyActiveTour() {
  if (activeDriver) {
    try {
      activeDriver.destroy();
    } catch {
      // driver may already be destroyed
    }
    activeDriver = null;
  }
}

export function getActiveDriver() {
  return activeDriver;
}

// Register Turbolinks teardown once
let teardownRegistered = false;

export function registerTurbolinksTeardown() {
  if (teardownRegistered) return;
  teardownRegistered = true;

  document.addEventListener('turbolinks:before-visit', () => {
    destroyActiveTour();
  });
}
